<template>
  <div class="partner">
    <va-card :title="$t('partner-report.cards.title')">
      <div class="row">
        <div class="flex md12">
          <div class="form-group mb-3">
            <va-select
              :label="$t('report-partners.forms.mesLabel')"
              v-model="mesSel"
              textBy="name"
              keyBy='id'
              no-clear
              :placeholder="$t('report-partners.forms.mesPlaceholder')"
              :noOptionsText="$t('report-partners.forms.mesNoOption')"
              maxHeight='200px'
              :options="optionsMes"
            />
            <va-select
              :label="$t('report-partners.forms.anosLabel')"
              v-model="anoSel"
              textBy="id"
              keyBy='id'
              no-clear
              :placeholder="$t('report-partners.forms.anosPlaceholder')"
              :noOptionsText="$t('report-partners.forms.anosNoOption')"
              maxHeight='200px'
              :options="optionsAno"
            />
          </div>
        </div>
      </div>
      <div class="row row-equal">
        <div class="flex xl12 xs12" style="text-align: center;">
          <img :src='"../../assets/logo/LOGO-100.png"' alt="logo"/>
        </div>
        <template v-if="values.length > 0">
          <template v-for="(item, idx) in values" >
            <div v-if="item[1]" :key="idx" class="flex xl12 xs12" style="text-align: center;">
              <b>{{ $t(`partner-report.report.${item[0]}`) }}:</b>
              {{
                reportPartners.length > 0 && Object.keys(reportPartners[0]).includes(item[1])
                  ? (
                    reportPartners[0][item[1]] !== null && (typeof reportPartners[0][item[1]]) === 'object' && reportPartners[0][item[1]].length > 0
                      ? (
                        item[1] === 'transacoes'
                          ? (
                            reportPartners[0][item[1]].filter(i => i.includes(item[2])).length > 0
                              ? reportPartners[0][item[1]].filter(i => i.includes(item[2]))[0].replace(item[2], '').trim()
                              : '0'
                          )
                          : (
                            reportPartners[0][item[1]].join(', ').length > 0
                              ? reportPartners[0][item[1]].join(', ')
                              : '0'
                          )
                      )
                      : (
                        reportPartners[0][item[1]]
                          ? reportPartners[0][item[1]]
                          : '0'
                      )
                  )
                  : item[1]}}
            </div>
          </template>
        </template>
        <div class="flex md12 xs12">
          <va-card
            v-if="clicksData"
            class="chart-widget"
            title="Cliques"
          >
            <line-chart class="chart" :chart-data="clicksData" :options="options"/>
          </va-card>
          <va-card
            v-if="clientsData"
            class="chart-widget"
            title="Clientes"
          >
            <line-chart class="chart" :chart-data="clientsData" :options="options"/>
          </va-card>
          <va-card
            v-if="paymentsData"
            class="chart-widget"
            title="Pagamentos"
          >
            <line-chart class="chart" :chart-data="paymentsData" :options="options"/>
          </va-card>
        </div>
      </div>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import LineChart from './LineChart.js'
export default {
  name: 'partner',
  components: { LineChart },
  props: {
    partner: {
      default: null,
      type: String,
    },
    ano: {
      default: null,
      type: String,
    },
    mes: {
      default: null,
      type: String,
    },
  },
  methods: {
    buscaDados () {
      if (Object.keys(this.$apollo.queries).includes('reportPartners')) {
        this.$apollo.queries.reportPartners.setVariables({
          id: this.partner ? this.partner : this.$store.getters['authenticate/user'].id,
          ano: this.valueAno,
          mes: this.valueMesId,
        })
        this.$apollo.queries.reportPartners.refetch()
      } else {
        this.$apollo.addSmartQuery('reportPartners', {
          query: this.partner ? gql`
          query MyQuery($mes: Int, $ano: Int!, $id: Int!) {
            reportPartners: partners_month(args: {mes: $mes, ano: $ano}, where: {id: {_eq: $id}}) {
              id
              name
              code
              transacoes_trial
              clientes_novos
              transacoes
              somatorio_transacoes
              clicks
              list_clicks
              list_clients
              list_payments
            }
          }
          ` : gql`
          query MyQuery($mes: Int, $ano: Int!, $id: Int!) {
            reportPartners: partners_month(args: {mes: $mes, ano: $ano}, where: {partner: {user_id: {_eq: $id}}}) {
              id
              name
              code
              transacoes_trial
              clientes_novos
              transacoes
              somatorio_transacoes
              clicks
              list_clicks
              list_clients
              list_payments
            }
          }
          `,
          variables () {
            return {
              id: this.partner ? this.partner : this.$store.getters['authenticate/user'].id,
              ano: this.valueAno,
              mes: this.valueMesId,
            }
          },
          result ({ data, loading }) {
            const moment = this.$moment
            if (!loading && Object.keys(data).includes('reportPartners')) {
              this.reportPartners = data.reportPartners
              if (Object.keys(data.reportPartners[0]).includes('list_clicks')) {
                this.clicks = data.reportPartners[0].list_clicks.map(c => {
                  return { x: c.data, y: c.value }
                })
                this.clicksData = {
                  labels: this.clicks.map(c => { return moment(c.x).format('DD/MM/YYYY') }), // months.splice(firstMonthIndex, size),
                  datasets: [
                    {
                      backgroundColor: '#f2e5e680',
                      borderColor: '#943435',
                      data: this.clicks,
                      tension: 0,
                    },
                  ],
                }
              }
              if (Object.keys(data.reportPartners[0]).includes('list_clients')) {
                this.clients = data.reportPartners[0].list_clients.map(c => {
                  return { x: c.data, y: c.value }
                })
                this.clientsData = {
                  labels: this.clients.map(c => { return moment(c.x).format('DD/MM/YYYY') }), // months.splice(firstMonthIndex, size),
                  datasets: [
                    {
                      backgroundColor: '#f2e5e680',
                      borderColor: '#943435',
                      data: this.clients,
                      tension: 0,
                    },
                  ],
                }
              }
              if (Object.keys(data.reportPartners[0]).includes('list_payments')) {
                this.payments = data.reportPartners[0].list_payments.map(c => {
                  return { x: c.data, y: c.value }
                })
                this.paymentsData = {
                  labels: this.payments.map(c => { return moment(c.x).format('DD/MM/YYYY') }), // months.splice(firstMonthIndex, size),
                  datasets: [
                    {
                      backgroundColor: '#f2e5e680',
                      borderColor: '#943435',
                      data: this.payments,
                      tension: 0,
                    },
                  ],
                }
              }
            }
          },
        })
      }
    },
  },
  data () {
    return {
      clicks: [],
      clients: [],
      payments: [],
      clicksData: null,
      clientsData: null,
      paymentsData: null,
      options: {
        legend: {
          display: false,
        },
        tooltips: {
          bodyFontSize: 14,
          bodyFontFamily: 'sans-serif',
        //   enabled: false,
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              min: 0,
              stepSize: 2,
            },
          }],
        },
      },
      anoSel: {},
      mesSel: {},
      values: [],
      optionsAno: [],
      optionsMes: [
        {
          id: 1, name: 'Janeiro',
        },
        {
          id: 2, name: 'Fevereiro',
        },
        {
          id: 3, name: 'Março',
        },
        {
          id: 4, name: 'Abril',
        },
        {
          id: 5, name: 'Maio',
        },
        {
          id: 6, name: 'Junho',
        },
        {
          id: 7, name: 'Julho',
        },
        {
          id: 8, name: 'Agosto',
        },
        {
          id: 9, name: 'Setembro',
        },
        {
          id: 10, name: 'Outubro',
        },
        {
          id: 11, name: 'Novembro',
        },
        {
          id: 12, name: 'Dezembro',
        },
      ],
      meses: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
      ],
      reportPartners: [],
    }
  },
  apollo: {
    optionsAno: {
      query: gql`
      query MyQuery {
        optionsAno: partners_years(order_by: {id: desc}) {
          id
        }
      }
      `,
      result ({ data, loading }) {
        if (!loading && data.optionsAno.length > 0) {
          this.anoSel = data.optionsAno[0]
        }
      },
    },
  },
  computed: {
    valueAno () {
      return this.ano === null ? this.anoSel.id : this.ano
    },
    valueMesId () {
      return this.mes === null ? this.mesSel.id : this.mes
    },
    valueMes () {
      return this.mes !== null ? this.meses[this.mes - 1] : (this.mesSel.id !== null ? this.mesSel.name : null)
    },
  },
  watch: {
    anoSel (_) {
      if (Object.keys(this.anoSel).length > 0 && Object.keys(this.mesSel).length > 0) {
        this.values = [
          ['year', this.valueAno],
          ['month', this.valueMes],
          ['partner', 'name'],
          ['newClients', 'clientes_novos'],
          ['clicks', 'clicks'],
          ['firstPayment', 'transacoes', 'Primeira'],
          ['renovations', 'transacoes', 'Renovacao'],
          ['trial', 'transacoes_trial'],
          ['value', 'somatorio_transacoes'],
        ]
        this.buscaDados()
      }
    },
    mesSel (_) {
      if (Object.keys(this.anoSel).length > 0 && Object.keys(this.mesSel).length > 0) {
        this.values = [
          ['year', this.valueAno],
          ['month', this.valueMes],
          ['partner', 'name'],
          ['newClients', 'clientes_novos'],
          ['clicks', 'clicks'],
          ['firstPayment', 'transacoes', 'Primeira'],
          ['renovations', 'transacoes', 'Renovacao'],
          ['trial', 'transacoes_trial'],
          ['value', 'somatorio_transacoes'],
        ]
        this.buscaDados()
      }
    },
  },
  mounted () {
    this.values = [
      ['year', this.valueAno],
      ['month', this.valueMes],
      ['partner', 'name'],
      ['newClients', 'clientes_novos'],
      ['clicks', 'clicks'],
      ['firstPayment', 'transacoes', 'Primeira'],
      ['renovations', 'transacoes', 'Renovacao'],
      ['value', 'somatorio_transacoes'],
    ]
    if (Object.keys(this.$apollo.queries).includes('reportPartners')) {
      this.$apollo.queries.reportPartners.refetch()
    }
    if (!this.mes) {
      this.mesSel = this.optionsMes[new Date().getMonth()]
    } else {
      this.mesSel = this.optionsMes[this.mes]
    }
  },
}
</script>

<style lang="scss">
.chart-widget {
  .va-card__body {
    height: 250px;
  }
}

.chart {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  > * {
    height: 100%;
    width: 100%;
  }

  canvas {
    width: 100%;
    height: auto;
  }
}
</style>
